import { render, staticRenderFns } from "./nutritionMealDialogSelectedRecipe.vue?vue&type=template&id=1b6564c6&scoped=true"
import script from "./nutritionMealDialogSelectedRecipe.vue?vue&type=script&lang=js"
export * from "./nutritionMealDialogSelectedRecipe.vue?vue&type=script&lang=js"
import style0 from "./nutritionMealDialogSelectedRecipe.vue?vue&type=style&index=0&id=1b6564c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6564c6",
  null
  
)

export default component.exports